import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData, postData, updateData, masterdataindex } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import Select from 'react-select';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import AddIcon from '@mui/icons-material/Add';

function BalanceSheetIndex() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);  // Modal state
    const [name, setName] = useState("");

    const history = useHistory();
    const { isAuthenticated, companyId, permissions, userId, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');
    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();

            return;
        }
        // Token is not expired, fetch data
        fetchtableData();
        setLoading(true);
    }, [isAuthenticated, companyId, userId, token, logout]);

    useEffect(() => {
        if (searchTerm.trim() === '') {
            setFilteredData(data);
        } else {
            const filtered = data.filter(item => item.name && item.name.toLowerCase().includes(searchTerm.toLowerCase()));
            setFilteredData(filtered);
        }
    }, [data, searchTerm]);

    const fetchtableData = async () => {
        setLoading(true);
        fetchData('BalanceSheetApi', `/${companyId}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setData(response.response_data);
                    setFilteredData(response.response_data);

                }
                console.log(response);
            })

            .catch((error) => {
                console.error('Error fetching BalanceSheet:', error);
                // Handle error, e.g., redirect to login if token is expired
                if (error.response && error.response.status === 401) {
                    logout();
                    // Redirect to login with the current location as a parameter
                    history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
                }
            })
            .finally(() => {
                setLoading(false); // Hide loading screen
            });
    };

    const handleDelete = async () => {
        deleteData('BalanceSheetApi', `${deleteItemId}`, token)
            .then(() => {
                setDeleteItemId(null);
                setConfirmDialogOpen(false);
                fetchtableData(); // Refresh data after deletion
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
                setErrorMessage('Network error occurred while deleting the record. Please try again.');
            });
    };

    const handleActivate = (itemId) => {
        activateData('BalanceSheetApi', `${itemId}`)
            .then(() => {
                // Fetch table data or update state
            })
            .catch((error) => {
                console.error('Error activating record:', error);
            });
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };


    const addRecord = async (e) => {
        e.preventDefault();
        
        if (!name.trim()) {
            setErrorMessage("Name is required.");
            return;
        }

        const CreateData = {
            Name: name,
            CreatedBy: userId,
            CompanyId: companyId,
            CreatedDate: new Date(),
        };

        postData('BalanceSheetApi', CreateData, token)
            .then((response) => {
                console.log('BalanceSheetHead Created success:', response);
                setSuccessMessage("BalanceSheetHead Created successfully!");
                setErrorMessage("");
                setName('');
                setIsModalOpen(false);
                window.location.reload();
                setTimeout(() => {
                    setSuccessMessage("");
                }, 3000);
            })
            .catch((error) => {
                console.error('Item Create error:', error);
                setIsLoading(false);
            });
    };


    //EDIT
    const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);

    const openDetailModal = async (id) => {
        try {
            const response = await fetchData('BalanceSheetApi', `/CategoryDetails/${id}`, token);
            if (response.responseCode === '1111') {
                setUpdateData(response.response_data);
                setIsDetailModalOpen(true);
            }
        } catch (error) {
            console.error('Error fetching Item Details:', error);
        }
    };

    const toggleModalBranch = () => {
        setIsDetailModalOpen(false); // Step 2
    };

    const handleUpdateInputChange = (event) => {
        const { name, value } = event.target;
        setUpdateData((prevDataItem) => ({
            ...prevDataItem,
            [name]: value,
        }));
    };

    const [updatedData, setUpdateData] = useState({});


    const updateRecord = async (event) => {
        event.preventDefault();

        try {

            await updateData('BalanceSheetApi', `${updatedData.Id}`, updatedData, token);
            setUpdateData({
                CompanyId: companyId,
                Name: '',
            });
            //fetchtableData();
            setIsDetailModalOpen(false);
            fetchtableData();
        } catch (error) {
            console.error('Error updating record:', error);
        }
    };


    return (
        <div className="w-full max-w-sm container mt-2 mx-auto">
            <div className='w-full mb-2 flex'>
                <h6 className='productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}>BALANCE SHEET</h6>
                <div className='w-1/4 mb-2 flex'>
                    <input
                        type="text"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="search-input shadow border rounded py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    />
                </div>
                {hasCreateMasterPermission && (
                    <Tooltip title="Add BalanceSheet">
                        <Button
                            style={{
                                background: 'linear-gradient(to right, #16423C,#6A9C89)',
                                padding: '10px 20px',
                                color: 'white',
                                fontWeight: 'bolder',
                                textTransform: 'none',
                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                maxHeight: '35px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginLeft: '5px'
                            }}
                            onClick={toggleModal}
                        >
                            + Add BalanceSheet
                        </Button>
                    </Tooltip>
                )}
            </div>

            {isModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center z-10">
                    <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '600px' }}>
                        <h6 style={{ color: 'brown', textAlign: 'center', fontWeight: 'bolder' }}>BALANCE SHEET CREATE</h6>
                        <div className="w-full mb-4 flex">
                            <div className="w-1/4 mr-2" style={{ width: '80%' }}>
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name">
                                    Name <span style={{ color: 'red' }}>*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    type="text"
                                    name="Name"
                                    placeholder="Enter Name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="w-1/2 mr-4" style={{ marginTop: '23px' }}>
                            <button className="bg-green-500 text-white px-4 py-2 rounded" onClick={addRecord}>
                                Add Record
                            </button>
                            <button className="bg-blue-500 text-white px-4 py-2 rounded ml-2" onClick={toggleModal}>
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto', width: '100%' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#134B70' }}>

                            <TableRow>
                                <TableCell sx={{ backgroundColor: '#134B70', borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Sl.No</TableCell>
                                <TableCell sx={{ backgroundColor: '#134B70', borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Name</TableCell>
                                <TableCell sx={{ backgroundColor: '#134B70', borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}></TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody style={{ backgroundColor: 'white' }}>
                            {filteredData.map((item, index) => (
                                <TableRow
                                    key={item.id}
                                    className={item.isActive ? '' : 'inactiveRow'}
                                    sx={{
                                        backgroundColor: index % 2 === 0 ? '#FFFFFF' : '#F5F5F5', // Alternates between white and light grey
                                    }}
                                >
                                    <TableCell
                                        sx={{
                                            borderBottom: '1px solid #FFE1E2',
                                            height: '40px',
                                            padding: '5px',
                                            color: 'black',
                                        }}
                                    >
                                        {index + 1}
                                    </TableCell>

                                    <TableCell
                                        sx={{
                                            borderBottom: '1px solid #FFE1E2',
                                            height: '40px',
                                            padding: '5px',
                                            color: 'black',
                                        }}
                                    >
                                        {item.name}
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            borderBottom: '1px solid #FFE1E2',
                                            height: '40px',
                                            padding: '5px',
                                            color: 'black',
                                            width: '15%',
                                            textAlign: 'right',
                                        }}
                                    >
                                        {hasEditMasterPermission && (
                                            <Tooltip title="Edit">
                                                <IconButton onClick={() => openDetailModal(item.id)}>
                                                    <EditIcon style={{ color: 'blueviolet' }} />
                                                </IconButton>
                                            </Tooltip>
                                        )}

                                        {hasDeleteMasterPermission && (
                                            <Tooltip title="Delete">
                                                <IconButton onClick={() => openConfirmDialog(item.id)}>
                                                    <DeleteIcon style={{ color: 'brown' }} />
                                                </IconButton>
                                            </Tooltip>
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>

                        <Dialog
                            open={confirmDialogOpen}
                            onClose={closeConfirmDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure you want to delete ?
                                </DialogContentText>
                            </DialogContent>

                            <DialogActions>
                                <button
                                    onClick={closeConfirmDialog}
                                    style={{
                                        backgroundColor: '#dc3545',
                                        color: '#ffffff',
                                        border: '1px solid #dc3545',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                        marginRight: '8px',
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleDelete}
                                    style={{
                                        backgroundColor: '#28a745',
                                        color: '#ffffff',
                                        border: '1px solid #28a745',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                    }}
                                >
                                    Confirm
                                </button>
                            </DialogActions>

                        </Dialog>
                    </Table>
                </TableContainer>
                {isDetailModalOpen && (
                    <div className="fixed inset-0 flex items-center justify-center z-10">
                        <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '600px' }}>
                            <h6 style={{ color: 'brown', textAlign: 'center', fontWeight: 'bolder' }}>BALANCE SHEET CREATE</h6>
                            <div className="w-full mb-4 flex">
                                <div className="w-1/4 mr-2" style={{ width: '80%' }}>
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name">
                                        Name <span style={{ color: 'red' }}>*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        type="text"
                                        name="Name"
                                        placeholder="Enter name"
                                        value={updatedData.Name}
                                        onChange={handleUpdateInputChange}

                                    />
                                </div>
                            </div>

                            <div className="w-1/2 mr-4" style={{ marginTop: '23px' }}>
                                <button className="bg-green-500 text-white px-4 py-2 rounded" onClick={updateRecord}>
                                    Add Record
                                </button>
                                <button className="bg-blue-500 text-white px-4 py-2 rounded ml-2" onClick={toggleModalBranch}>
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default BalanceSheetIndex;
